export default {
  getList: (state) => {
    return state.list
  }
}
